import { render, staticRenderFns } from "./Dimission.vue?vue&type=template&id=306b8f7e&"
import script from "./Dimission.vue?vue&type=script&lang=js&"
export * from "./Dimission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports